import React from 'react';

const StatusPopup = ({ show, type, message, onClose }) => {
    if (!show) {
        return null;
    }

    const isSuccess = type === 'success';

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 shadow-2xl w-full max-w-lg mx-auto text-center">
                <div className="mb-4 flex justify-center">
                    {isSuccess ? (
                        <div className="w-20 h-20 rounded-full bg-green-500 flex items-center justify-center">
                            <svg className="h-12 w-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                    ) : (
                        <div className="w-20 h-20 rounded-full bg-red-500 flex items-center justify-center">
                            <svg className="h-12 w-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                    )}
                </div>
                <p className="text-[2rem] mb-6 text-gray-700">{message}</p>
                <button
                    onClick={onClose}
                    className="bg-blue-500 text-white font-bold py-3 px-6 text-[1.3rem] rounded-lg hover:bg-blue-600 transition-colors duration-300"
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default StatusPopup;
